<template>
    <div>
        <v-app-bar color="#F3F4F6" style="border-bottom: 1px solid #D2D6DB;"
                    v-if="isNotPublicSurvey">
            <v-toolbar-title>
                <v-btn to="/" elevation="0">
                    <v-icon class="me-2" color="#384250">mdi-home</v-icon>
                    <span class="hometitle">{{ $t('HomePage') }}</span>
                </v-btn>
            </v-toolbar-title>
            <v-menu tile rounded="0" offset-y>
                <template #activator="{ attrs, on }">
                    <v-btn class="dark--text mr-2" elevation="0" tile :loading="changingLanguage" v-bind="attrs" v-on="on">
                        <v-icon color="#384250">
                            mdi-earth
                        </v-icon>
                        {{ isArabicLanguage ? 'العربية' : 'English' }}
                    </v-btn>
                </template>
                <v-spacer />
                <v-list tile dense color="grey lighten-4" class="pb-0">
                    <template v-if="isArabicLanguage">
                        <v-list-item @click="changeLanguage('en')">
                            <v-list-item-title>
                                <h4>
                                    English
                                </h4>
                            </v-list-item-title>
                        </v-list-item>
                        <v-divider />
                    </template>
                    <template v-else>
                        <v-list-item @click="changeLanguage('ar')">
                            <v-list-item-title>
                                <h4>
                                    العربية
                                </h4>
                            </v-list-item-title>
                        </v-list-item>
                        <v-divider />
                    </template>
                </v-list>
            </v-menu>
            <v-spacer></v-spacer>
            <v-btn v-if="showAction" text to="/register" class="me-4">
                <v-icon class="me-2">mdi-account-plus</v-icon>
                <span class="hometitle">{{ $t('Register') }}</span>
            </v-btn>
            <v-btn text to="/login">
                <v-icon color="#384250">mdi-account</v-icon>
                <span class="hometitle">{{ $t('Login') }}</span>
            </v-btn>
        </v-app-bar>
        <v-app-bar elevation="0" height="auto" dense color="#FFF" style="position:fixed; width:100%; z-index:1000;" hide-on-scroll v-if="!scrolled && isNotPublicSurvey">
            <v-container fluid>
                <v-row>
                    <v-col cols="7" md="1" class="text-end"> <img :style="`height:70px;float:${ language == 'ar'?'right':'left' }`" src="../../assets/images/mh-logo-full.png" /></v-col>
                    <v-col cols="1" md="10"></v-col>
                </v-row>
            </v-container>
        </v-app-bar>
        <v-app-bar elevation="0" height="auto" dense color="#FFF"  v-if="!isNotPublicSurvey">
            <v-container fluid>
                <v-row>
                    <v-col cols="7" md="1" class="text-end"> <img :style="`height:45px;float:${ language == 'ar'?'right':'left' }`" src="../../assets/images/mh-logo-full.png" /></v-col>
                    <v-col cols="1" md="10"></v-col>
                </v-row>
            </v-container>
        </v-app-bar>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { clearTranslation } from '@/plugins/i18n/index.js'
    import SettingsService from '@/services/SettingsService'
       
    export default {

        data() {
            return {                
                changingLanguage: false,
                showAction: false,
                scrolled: false
            }
        },
        created() {
            this.isShowAction()
        },
        computed: {
            ...mapGetters('user', ['language']),

            isArabicLanguage() {                
                return this.language == 'ar'                
            },
            isNotPublicSurvey() {
                return this.$route.name != 'form' || this.$route.query.viewMode
            },
        },

        mounted() {
            this.currentLanguage = this.language      
            window.addEventListener('scroll', this.onScroll)
        },

        methods: {
            onScroll() {
                // Check scroll position and toggle app bars
                this.scrolled = window.scrollY > 10 && this.$route.name != 'form' || this.$route.query.viewMode // Adjust threshold as needed
            },
            isShowAction() {
                SettingsService.isShowAddNewUser().then(res => {
                    if (res.data) {
                        this.showAction = res.data.toLowerCase() === 'true'
                    }
                })

            },
            changeLanguage(language) {                
                clearTranslation()
                this.language == language
                this.$store.dispatch('user/setLanguage', language)               
                this.$router.go()
                this.changingLanguage = false
            }
        }
    }
</script>

<style>
    ul.top-header-menu * {
        color: #dedede;
    }

    ul.top-header-menu li {
        display: inline-block;
        padding: 0 15px
    }

    li.dot {
        width: 6px;
        height: 6px;
        background: #ffffff54;
        border-radius: 50px !important;
        padding: 0px !important
    }

    ul.top-header-menu li .dropdown-item {
        display: block;
        width: 100%;
        padding: 5px;
        color: #384250;
        font-weight: 400;
        font-size: 1rem;
        text-align: inherit;
        white-space: nowrap;
        text-decoration: none;
        font-weight: 600;
    }

    ul.top-header-menu li:first-child .dropdown-item {
        padding: 5px;
        background: #074d31;
        border-radius: 6px !important;
        color: #FFF;
    }
    .v-btn--active:before, .v-btn:before {
        background-color: #1B8354!important;
    }
    .v-btn {
        border-radius: 6px;
    }
</style>